export interface TtcSegmentedOption {
  analyticsElementCustomId?: string;
  label: string;
  useTemplate: true;
  value: string;
}

export const ttcSegmentedSizeDefault = 'default';
export const ttcSegmentedSizeLarge = 'large';
export const ttcSegmentedSizeSmall = 'small';
